import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Grid,
    Typography
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTheme } from '@mui/material/styles';
import styled from '@emotion/styled';
// import { useDispatch } from 'react-redux';
// import { getFileURL } from 'common/redux.actions';
// import { Link } from 'react-router-dom';

const StyledTitle = styled(Typography)(({ theme: { typography } }) => ({
    display: 'flex',
    ...typography.h6,
    fontWeight: typography.fontWeightBold,
    whiteSpace: 'nowrap'
}));

const StyledAccordionSummary = styled(AccordionSummary)(
    ({ theme: { palette } }) => ({
        backgroundColor: palette.background.paper,
        borderBottom: `1px solid ${palette.divider}`,
        margin: 0,
        '&>div': { margin: '0 !important' }
    })
);

const ShiftAccordion = ({ expanded, onChange, panelId, title, dataInfo }) => {
    const theme = useTheme();

    // const RXDispatch = useDispatch();

    // const handleLink = async (e) => {
    //     e.preventDefault();
    //     RXDispatch(
    //         getFileURL({
    //             handleSubmit,
    //             payload: { url: e.target.href }
    //         })
    //     );
    // };

    // const handleSubmit = (resp) => {
    //     if (resp.type === 'success') {
    //         window.open(resp.url, '_blank');
    //     }
    // };

    return (
        <Accordion
            expanded={expanded === panelId}
            onChange={onChange(panelId)}
            sx={{ m: 0 }}
        >
            <StyledAccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`${panelId}bh-content`}
                id={`${panelId}bh-header`}
            >
                <StyledTitle>{title}</StyledTitle>
            </StyledAccordionSummary>
            <AccordionDetails sx={{ p: 4 }}>
                <Grid
                    container
                    spacing={1}
                    sx={{ justifyContent: 'space-between' }}
                >
                    {dataInfo?.data ? (
                        Object.entries(dataInfo.data).map(([key, value]) => (
                            <Grid item xs={5} key={key}>
                                <Grid container>
                                    <Grid item xs={5}>
                                        <Typography sx={{ fontWeight: 'Bold' }}>
                                            {key}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            : {value || 'N/A'}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))
                    ) : (
                        <Typography>No data available</Typography>
                    )}
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default ShiftAccordion;
